import { Select } from "@hireart/component-library";
import PropTypes from "prop-types";
import { formatHourlyRate } from "common/utils/timesheet";

export const ShiftTagSelector = ({
  selectedProjectToken = null,
  isReadOnly,
  projectOptions,
  onProjectChange,
}) => {
  // Don't render if no project options are available
  if (!projectOptions || projectOptions.length === 0) {
    return null;
  }

  const handleProjectChange = (_e, value) => {
    // Parse the combined value to extract projectToken and payRateId
    const [projectToken, payRateId] = value.split("|");
    onProjectChange(projectToken, payRateId);
  };

  // Convert project options to Select format
  const selectOptions = projectOptions.map((option) => {
    const rateFragment = formatHourlyRate(option.hourlyRate, option.currency);
    return {
      value: `${option.token}|${option.payRateId}`,
      // Combine token and payRateId for the value
      text: rateFragment ? `${option.name} (${rateFragment})` : option.name,
    };
  });

  // Find current value
  const currentValue = selectedProjectToken
    ? projectOptions.find((opt) => opt.token === selectedProjectToken)
    : null;
  const selectValue = currentValue
    ? `${currentValue.token}|${currentValue.payRateId}`
    : "";

  return (
    <Select
      label="Shift tag"
      placeholder="Select shift tag..."
      value={selectValue}
      onChange={handleProjectChange}
      options={selectOptions}
      isDisabled={isReadOnly}
      isOptional={false}
      isLabelUnstyled
      id="shift-purpose"
      size="md"
    />
  );
};

ShiftTagSelector.propTypes = {
  selectedProjectToken: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.oneOf([null]),
  ]),
  isReadOnly: PropTypes.bool.isRequired,
  projectOptions: PropTypes.arrayOf(
    PropTypes.shape({
      token: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      payRateId: PropTypes.string.isRequired,
      payRateName: PropTypes.string.isRequired,
      hourlyRate: PropTypes.number.isRequired,
      currency: PropTypes.string,
    })
  ).isRequired,
  onProjectChange: PropTypes.func.isRequired,
};
